import React from 'react';
import { SectionProps } from '../../types/section';

interface CardProps extends SectionProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  className = '',
  padding = 'md',
  hoverable = true,
  sectionId
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const baseClasses = `
    bg-bg-card 
    border border-border-primary 
    rounded-xl 
    shadow-base
    transition-all 
    duration-base
    ${hoverable ? 'hover:shadow-lg hover:border-border-secondary' : ''}
    ${paddingClasses[padding]}
    ${className}
  `;

  return (
    <div className={`${baseClasses} relative`} data-section-id={sectionId}>
      {title && (
        <h2 className="title-card">{title}</h2>
      )}
      {children}
    </div>
  );
};

export default Card;